import * as React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  CardContent,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { message } from "antd";

const UpdateTuition = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const { tuitionId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  // Get tuition data from navigation state
  const { tuitionData } = location.state || {};

  // Initialize state with passed data or empty values
  const [tuition_fee, setTuition_fee] = React.useState(
    tuitionData?.tuition_fee || ""
  );
  const [discount_amount, setDiscount_amount] = React.useState(
    tuitionData?.discount_amount || ""
  );
  const [reason, setReason] = React.useState(tuitionData?.reason || "");
  const token = localStorage.getItem("token");
  const direction = ["ar", "ku"].includes(i18n.language) ? "rtl" : "ltr";
  const textAlign = ["ar", "ku"].includes(i18n.language) ? "right" : "left";

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedValues = {
        tuition_fee,
        discount_amount,
        reason,
        discount_type: "currency",
      };

      await axios.put(
        `https://api.clever-school.com/api/students/update-tuition/${tuitionId}`,
        updatedValues,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      message.success(t("tuitionUpdated"));
      navigate("/GetStudent");
    } catch (error) {
      console.error("Update error:", error);
      message.error(t("tuitionUpdateFailed"));
    }
  };
  const formFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#f5f5f5",
      borderRadius: "8px",
      "& fieldset": { border: "none" },
      "&:hover fieldset": { border: "none" },
      "&.Mui-focused fieldset": {
        border: "none",
        boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.2)",
      },
    },
    "& .MuiInputBase-input": {
      padding: "12px 14px",
    },
  };

  return (
    <Box
      sx={{
        maxWidth: 1200,
        margin: "40px auto",
        padding: theme.spacing(3),
        direction,
        textAlign,
        [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
      }}
    >
      <Paper
        elevation={2}
        sx={{
          borderRadius: 4,
          padding: theme.spacing(4),
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Box component="form" onSubmit={handleSubmit}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 500, mb: 3 }}>
            {t("updateTuition")}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  {t("tuitionFee")}
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  value={tuition_fee}
                  onChange={(e) => setTuition_fee(e.target.value)}
                  required
                  sx={formFieldStyles}
                  variant="outlined"
                />
              </CardContent>
            </Grid>

            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  {t("discountAmount")}
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  value={discount_amount}
                  onChange={(e) => setDiscount_amount(e.target.value)}
                  required
                  sx={formFieldStyles}
                  variant="outlined"
                />
              </CardContent>
            </Grid>

            <Grid item xs={12}>
              <CardContent>
                <Typography variant="subtitle2" gutterBottom>
                  {t("reason")}
                </Typography>
                <TextField
                  fullWidth
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  multiline
                  sx={formFieldStyles}
                  rows={3}
                  variant="outlined"
                />
              </CardContent>
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{
                  mt: 4,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => navigate("/GetStudent")}
                  sx={{
                    color: theme.palette.error.main,
                    borderColor: theme.palette.error.main,
                  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: theme.palette.success.main,
                    "&:hover": {
                      backgroundColor: theme.palette.success.dark,
                    },
                  }}
                >
                  {t("update")}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default UpdateTuition;
